import {
    g as getLocaleTime,
    c as cloneObject,
    b as _objectSpread2,
    d as __vue_normalize__,
    e as __vue_create_injector__,
} from './index-cb588f9f.js';
import 'vue';

var script = {
    props: [
        'creator',
        'index',
        'cellData',
        'constructedEvents',
        'temporaryEvent',
    ],
    inject: ['kalendar_options'],
    components: {
        KalendarEvent: function KalendarEvent() {
            return import('./kalendar-event-165d650e.js');
        },
    },
    computed: {
        cell_events: function cell_events() {
            var all_events = [];

            if (this.completed_events) {
                all_events = all_events.concat(this.completed_events);
            }

            if (this.being_created) {
                all_events = all_events.concat(this.being_created);
            }

            return all_events;
        },
        completed_events: function completed_events() {
            return (
                this.constructedEvents &&
                // eslint-disable-next-line no-prototype-builtins
                this.constructedEvents.hasOwnProperty(this.cellData.value) &&
                this.constructedEvents[this.cellData.value]
            );
        },
        being_created: function being_created() {
            return (
                this.temporaryEvent &&
                this.temporaryEvent.start.value === this.cellData.value &&
                this.temporaryEvent
            );
        },
        overlappingEvents: function overlappingEvents() {
            var _this = this;

            if (!this.constructedEvents || this.cell_events.length < 1)
                return [];
            return Object.values(this.constructedEvents)
                .flat()
                .filter(function(event) {
                    var cellDate = new Date(_this.cellData.value);
                    var eventStarts = new Date(event.start.value);
                    var eventEnds = new Date(event.end.value);
                    return eventStarts < cellDate && eventEnds > cellDate;
                });
        },
        overlapValue: function overlapValue() {
            var length = this.overlappingEvents.length;
            return length > 2 ? 2 : length;
        },
        selected: function selected() {
            return this.cell_events && this.cell_events.length > 0;
        },
        hasPopups: function hasPopups() {
            return (
                this.selected &&
                !!this.cell_events.find(function(ev) {
                    return ev.status === 'popup-initiated';
                })
            );
        },
    },
    methods: {
        mouseDown: function mouseDown() {
            // user mouse got depressed while outside kalendar-cells
            // came back in and clicked while the creator was on
            if (this.creator.creating) {
                this.mouseUp();
                return;
            }

            var _this$kalendar_option = this.kalendar_options,
                read_only = _this$kalendar_option.read_only,
                overlap = _this$kalendar_option.overlap,
                past_event_creation = _this$kalendar_option.past_event_creation;
            if (read_only) return; // if past_event_creation is set to false, check if cell value is
            // before current time

            if (past_event_creation === false) {
                var now = getLocaleTime(new Date());

                if (new Date(now) > new Date(this.cellData.value)) {
                    this.mouseUp();
                    return;
                }
            } // if overlap is set to false, prevent selection on top of
            // other events
            if (!overlap && this.cell_events.length > 0) return; // close any open popups in the whole kalendar instance
            // before starting a new one

            this.$kalendar.closePopups(); // create a payload consisting of
            // starting, current, ending and originalStarting cell
            // starting, current and ending are self explanatory
            // but originalStarting cell is required
            // to determine the direction of the scroll/drag

            var payload = {
                creating: true,
                original_starting_cell: cloneObject(this.cellData),
                starting_cell: cloneObject(this.cellData),
                current_cell: cloneObject(this.cellData),
                ending_cell: cloneObject(this.cellData),
            };
            this.$emit('select', payload);
        },
        mouseMove: function mouseMove() {
            // same guards like in the mouseDown function
            var _this$kalendar_option2 = this.kalendar_options,
                read_only = _this$kalendar_option2.read_only;
            if (read_only) return;
            if (this.creator && !this.creator.creating) return;
            var _this$creator = this.creator,
                starting_cell = _this$creator.starting_cell,
                original_starting_cell = _this$creator.original_starting_cell,
                creating = _this$creator.creating; // direction of scroll

            var going_down =
                this.cellData.index >= starting_cell.index &&
                starting_cell.index === original_starting_cell.index;

            if (creating) {
                var payload = _objectSpread2({}, this.creator, {
                    current_cell: this.cellData,
                    ending_cell: this.cellData,
                    direction: going_down ? 'normal' : 'reverse',
                });

                this.$emit('select', payload);
            }
        },
        mouseUp: function mouseUp() {
            if (this.kalendar_options.read_only) return;

            if (this.creator.creating) {
                this.$emit('initiatePopup');
            }
        },
        resetCreator: function resetCreator() {
            this.$emit('reset');
        },
    },
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.cellData.visible
        ? _c(
              'li',
              {
                  staticClass: 'kalendar-cell',
                  class: {
                      selected: _vm.selected,
                      'is-an-hour': (_vm.index + 1) % (60 / 10) === 0,
                      'has-events':
                          _vm.cell_events && _vm.cell_events.length > 0,
                      'being-created': !!_vm.being_created || _vm.hasPopups,
                  },
                  style:
                      '\n  height: ' +
                      _vm.kalendar_options.cell_height +
                      'px;\n',
                  on: {
                      mouseover: function mouseover($event) {
                          if ($event.target !== $event.currentTarget) {
                              return null;
                          }

                          return _vm.mouseMove();
                      },
                      mousedown: function mousedown($event) {
                          if ($event.target !== $event.currentTarget) {
                              return null;
                          }

                          return _vm.mouseDown();
                      },
                      mouseup: function mouseup() {
                          return _vm.mouseUp();
                      },
                  },
              },
              _vm._l(_vm.cell_events, function(event, eventIndex) {
                  return _vm.cell_events && _vm.cell_events.length
                      ? _c('KalendarEvent', {
                            key: eventIndex,
                            style: 'z-index: 10',
                            attrs: {
                                event: event,
                                total: _vm.cell_events.length,
                                index: eventIndex,
                                overlaps: _vm.overlapValue,
                            },
                        })
                      : _vm._e();
              }),
              1
          )
        : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
    if (!inject) return;
    inject('data-v-bc1c5858_0', {
        source:
            'li{font-size:13px;position:relative}.created-events{height:100%}ul.building-blocks li{z-index:0;border-bottom:dotted 1px var(--odd-cell-border-color)}ul.building-blocks li.first_of_appointment{z-index:1;opacity:1}ul.building-blocks li.is-an-hour{border-bottom:solid 1px var(--table-cell-border-color)}ul.building-blocks li.has-events{z-index:unset}ul.building-blocks li.being-created{z-index:11}',
        map: undefined,
        media: undefined,
    });
};
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = __vue_normalize__(
    {
        render: __vue_render__,
        staticRenderFns: __vue_staticRenderFns__,
    },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
);

export default __vue_component__;
